import {Component, computed, effect, inject, OnInit, signal, untracked} from '@angular/core';
import {toObservable} from '@angular/core/rxjs-interop';
import {debounceTime} from 'rxjs';
import {NgxSpinnerService} from 'ngx-spinner';
import {SharedModule} from '../../../../core/modules/shared.module';
import {MaterialModule} from '../../../../core/modules/material.module';
import {PagesContainerComponent} from '../../pages-container/pages-container.component';
import {ParishOrganizationService} from '../../../../core/services/parishOrganization.service';

@Component({
  selector: 'app-parish-organization',
  templateUrl: './parishOrganization.component.html',
  styleUrls: ['./parishOrganization.component.scss'],
  imports: [SharedModule, MaterialModule, PagesContainerComponent]
})
export class ParishOrganizationComponent implements OnInit {
  private parishOrgService = inject(ParishOrganizationService);
  private spinner = inject(NgxSpinnerService);

  parishOrganizations = signal<any[]>([]);
  pageIndex = signal(0);
  perPage = signal(50);
  sort = signal('createdAt');
  direction = signal('desc');
  search = signal('');
  pagination = signal<any>(null);

  readonly displayedColumns = signal<string[]>([
    'title',
    'country',
    'canton',
    'responsible',
    'president',
    'status'
  ]);

  constructor() {
    effect(() => {
      const s = this.search();
      untracked(() => {
        if (this.pageIndex() !== 0) {
          this.pageIndex.set(0);
        }
      });
    });

    const trigger = computed(() => {
      return {
        page: this.pageIndex(),
        size: this.perPage(),
        sort: this.sort(),
        dir: this.direction(),
        search: this.search()
      };
    });

    toObservable(trigger).pipe(debounceTime(300)).subscribe(() => {
      this.getParishOrganizations();
    });
  }

  ngOnInit() {
  }

  getParishOrganizations() {
    this.spinner.show();
    this.parishOrgService.findParishOrganization(
      this.pageIndex() + 1,
      this.perPage(),
      this.sort(),
      this.direction(),
      this.search()
    ).subscribe({
      next: (res: any) => {
        this.parishOrganizations.set(res?.data || res?.parishOrganizations || res || []);
        this.pagination.set(res?.pagination || null);
        this.spinner.hide();
        this.restoreScroll();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  }

  handleSearch(value: string) {
    this.search.set(value);
  }

  handlePageEvent(e: any) {
    this.pageIndex.set(e.pageIndex);
    this.perPage.set(e.pageSize);
  }

  sortData(e: any) {
    if (!e.direction) {
      this.sort.set('createdAt');
      this.direction.set('desc');
    } else {
      this.sort.set(e.active);
      this.direction.set(e.direction);
    }
    localStorage.setItem('parishOrganizationSort', this.sort());
    localStorage.setItem('parishOrganizationSortDirection', this.direction());
    this.restoreScroll();
  }

  private restoreScroll() {
    localStorage.setItem('parishOrganizationScroll', '0');
    const table = document.getElementById('eventPage');
    if (table) {
      table.scrollTop = 0;
    }
  }

  onScroll(e: any) {
    localStorage.setItem('parishOrganizationScroll', e.target.scrollTop);
  }
}
